var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 19.5151C9 20.2651 8.79 20.9751 8.42 21.5751C7.73 22.7351 6.46 23.5151 5 23.5151C3.54 23.5151 2.27 22.7351 1.58 21.5751C1.21 20.9751 1 20.2651 1 19.5151C1 17.3051 2.79 15.5151 5 15.5151C7.21 15.5151 9 17.3051 9 19.5151Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44141 19.5146L4.43141 20.5046L6.56141 18.5347",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7514 7.5651C17.5114 7.5251 17.2614 7.51512 17.0014 7.51512H7.00141C6.72141 7.51512 6.45141 7.53511 6.19141 7.57511C6.33141 7.29511 6.53141 7.03515 6.77141 6.79515L10.0214 3.53514C11.3914 2.17514 13.6114 2.17514 14.9814 3.53514L16.7314 5.3051C17.3714 5.9351 17.7114 6.7351 17.7514 7.5651Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.5151V17.5151C22 20.5151 20 22.5151 17 22.5151H7.63C7.94 22.2551 8.21 21.9351 8.42 21.5751C8.79 20.9751 9 20.2651 9 19.5151C9 17.3051 7.21 15.5151 5 15.5151C3.8 15.5151 2.73 16.0451 2 16.8751V12.5151C2 9.79514 3.64 7.89513 6.19 7.57513C6.45 7.53513 6.72 7.51514 7 7.51514H17C17.26 7.51514 17.51 7.52512 17.75 7.56512C20.33 7.86512 22 9.77514 22 12.5151Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.0151H19C17.9 13.0151 17 13.9151 17 15.0151C17 16.1151 17.9 17.0151 19 17.0151H22",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.bee8b277def0d012aa6621dc5c876628.svg";
export { ForwardRef as ReactComponent };